(function () {
  'use strict';
  
  angular.module('ringbaPortal.services').factory('accountSettingsService', accountSettingsService);
  
  function accountSettingsService(
    $http,
    ngAuthSettings
  ) {
    'ngInject';

    const shakenStirOptions = [
      { name: 'A', value: 'A' },
      { name: 'A / B', value: 'AB' },
      { name: 'A / B / C', value: 'ABC' },
    ];

    const service = {
      updateSettings: updateSettings,
      loadSettings: loadSettings,
      shakenStirSettingOptions: shakenStirOptions
    };

    return service;

    function updateSettings(accountId, accountSetting){
      const url = _getBaseUrl(accountId);
      return $http.put(url, accountSetting);
    }

    function loadSettings(accountId){
      const url = _getBaseUrl(accountId);
      return $http.get(url);
    }
    
    function _getBaseUrl(accountId) {
      return ngAuthSettings.apiServiceBaseUri + accountId  + '/accountsettings/';
    }
  }
})();